import Fondo from "../assets/people.jpeg";
import { motion } from "framer-motion";

const QuienesSomos = () => {
  return (
    <div className="w-full h-auto md:h-screen md:flex">
      <motion.div
        className="w-full md:w-1/2"
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <img
          src={Fondo}
          alt="Quienes Somos"
          className="h-full w-auto object-contain"
        />
      </motion.div>
      <motion.div
        className="w-full md:w-1/2 flex flex-col justify-center px-6 md:px-16 gap-6"
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <h1 className="text-4xl md:text-6xl font-bold text-red-700">
          Quiénes somos
        </h1>
        <p className="text-gray-600 text-base md:text-lg text-justify">
          IN MOBILE ARQUITECTOS se encarga de todo tipo de renovaciones y desarrollo de proyectos arquitectónicos.
          <br/>
          Somos una empresa multiservicios relacionada con la construcción, remodelación y mantenimiento industrial, comercial y residencial.
        </p>
      </motion.div>
    </div>
  );
};

export default QuienesSomos;
